import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Form, Button, Alert } from 'react-bootstrap';
import '../asset/css/index.css';
import { Link } from "react-router-dom";

const Login = () => {
    const auth = useContext(AuthContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');
        try {
            await auth?.signIn(email.trim().toLowerCase(), password);
            window.location.href = "/";
        } catch (error) {
            setError('Adresse e-mail ou mot de passe invalide.');
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-left">
                    <h1>BACK-OFFICE TECHSITE</h1>
                    <p>Administration de l’application techsite</p>
                    <div className="login-illustration" />
                </div>

                <div className="login-right">
                    <h2 className="login-title">Authentification</h2>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Control
                                type="email"
                                placeholder="Adresse e-mail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="custom-input"
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Control
                                type="password"
                                placeholder="Mot de passe"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="custom-input"
                                required
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" className="w-100 login-button">
                            Connexion
                        </Button>
                    </Form>
                    <div className="text-center mt-3">
                        <Link to="/forgot-password" className="login-forgot">Mot de passe oublié ?</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;